import React from "react";
import { IconCircle, IconUserDeny, IconUserApprove, IconInfo } from '@sfx/icons';
import { RequestStatusEnum } from "../types";
import { getIntNumbersFromString } from '../../../../utils/utils';
export function RequestStatus(props) {
  var prefix = props.prefix,
      translate = props.translate,
      isProcessed = props.isProcessed,
      processedMsg = props.processedMsg,
      request = props.request,
      canApprove = props.canApprove,
      onApprove = props.onApprove,
      onReject = props.onReject;
  var componentClass = "".concat(prefix, "-user-request-modal-status");
  var statusInfo = getStatus(request.status, componentClass, translate);
  return /*#__PURE__*/React.createElement("div", {
    className: componentClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-info")
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconCircle, {
    size: "12",
    className: statusInfo.className
  })), /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-text")
  }, statusInfo.text), request.status === RequestStatusEnum.pending && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-approve-icon"),
    onClick: onReject
  }, /*#__PURE__*/React.createElement(IconUserDeny, {
    size: 20
  })), /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-reject-icon ").concat(!canApprove ? 'disabled' : ''),
    onClick: function onClick() {
      if (!canApprove) return;
      onApprove();
    }
  }, /*#__PURE__*/React.createElement(IconUserApprove, {
    size: 20
  })))), request.status === RequestStatusEnum.pending && isProcessed === true && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconInfo, {
    size: "14",
    className: "".concat(componentClass, "-warn-icon")
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-text ").concat(componentClass, "-text-small")
  }, getProcessedMsg(processedMsg, translate))));
}

function getProcessedMsg(processedMsg, translate) {
  switch (processedMsg.status) {
    case RequestStatusEnum.approved:
      return translate('SFxAccountSettingsUserRequestAlreadyProcessedApproved');

    case RequestStatusEnum.rejected:
      return translate('SFxAccountSettingsUserRequestAlreadyProcessedDenied');

    case RequestStatusEnum.solved:
      return translate('SFxAccountSettingsUserRequestAlreadyProcessedSolved');

    case RequestStatusEnum.threshold:
      // eslint-disable-next-line no-case-declarations
      var errorMessage = processedMsg.message.errorMessage; // eslint-disable-next-line no-case-declarations

      var str = errorMessage.length ? errorMessage[0] : ''; // eslint-disable-next-line no-case-declarations

      var numArr = getIntNumbersFromString(str);

      if (numArr) {
        var thresholdValue = numArr[0];
        var currentValue = numArr[1];
        return translate('SFxAccountSettingsUserRequestAlreadyProcessedThreshold', thresholdValue, currentValue);
      } else {
        return '';
      }

    default:
      return '';
  }
}

function getStatus(status, componentClass, translate) {
  switch (status) {
    case RequestStatusEnum.pending:
      return {
        className: "".concat(componentClass, "-pending"),
        text: translate('SFxAccountSettingsUserRequestStatusPending')
      };

    case RequestStatusEnum.approved:
      return {
        className: "".concat(componentClass, "-approved"),
        text: translate('SFxAccountSettingsUserRequestStatusApproved')
      };

    case RequestStatusEnum.rejected:
      return {
        className: "".concat(componentClass, "-denied"),
        text: translate('SFxAccountSettingsUserRequestStatusDenied')
      };

    case RequestStatusEnum.solved:
      return {
        className: "".concat(componentClass, "-solved"),
        text: translate('SFxAccountSettingsUserRequestStatusSolved')
      };

    default:
      return {
        className: "".concat(componentClass, "-pending"),
        text: translate('SFxAccountSettingsUserRequestStatusPending')
      };
  }
}